import { createMayBeFor, isJust } from "@omni/utils/maybe.utils";

import { PaintConfiguration } from "@/utils/productConfiguration/visuals/paintConfiguration/paintConfigurator.types";

export const isPaintConfiguration = (
    data: any | null
): data is PaintConfiguration => {
    const maybePaintConfiguration = createMayBeFor<PaintConfiguration>(
        [
            "paintInfo.colorHex",
            "paintInfo.colorName",
            "paintInfo.colorId",
            "paintInfo.family",
            "paintInfo.finish",
            "paintInfo.volume"
        ],
        data
    );
    return isJust(maybePaintConfiguration);
};
